// Route Constants

export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  UPLOAD: '/upload',
  DOCUMENTS: '/documents',
  DOCUMENT_DETAIL: '/documents/:id',
  ANALYSIS: '/analysis/:id',
  SETTINGS: '/settings',
  // Future routes
  CHAT: '/chat',
  INSIGHTS: '/insights',
} as const;
